import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { UserCog } from 'lucide-react'
import { RolesScreen } from '@/screens/org/SCR-048-roles'

export const Route = createFileRoute('/_app/org/roles')({
  staticData: { screen: { id: 'SCR-048', title: 'Roles & permissions', group: 'Organisation', perm: 'identity.manage', order: 3, description: 'What each role may do, and custom roles of your own.', icon: UserCog } },
  validateSearch: z.object({
    new: z.preprocess(v => v === true || v === 1 || v === '1' || v === 'true', z.boolean()).optional().catch(undefined),
  }),
  component: RolesScreen,
})
